<template>
    <v-app id="inspire">
        <v-main>
            <v-container
                    class="fill-height"
                    fluid
            >
                <v-row
                        align="center"
                        justify="center"
                >
                    <v-col
                            cols="12"
                            sm="8"
                            md="4"
                    >
                        <div  class="d-flex flex-column mb-6">

                            <img src="../assets/systematix-logo-min.png"  width="305" />
                        </div>
                        <v-alert type="error" v-if="submitError !== null">
                            {{submitError}}
                        </v-alert>
                        <v-card class="elevation-12"
                        :loading="submitStatus === 'PENDING' ? 'secondary' : false">
                            <v-form @submit="login()" @submit.prevent="() => {return true}" >
                            <v-toolbar
                                    color="primary"
                                    dark
                                    flat
                            >
                                <v-toolbar-title>Login</v-toolbar-title>

                            </v-toolbar>
                            <v-card-text>
                                    <v-text-field
                                            id="username"
                                            label="username"
                                            name="email"
                                            prepend-icon="mdi-account"
                                            type="text"
                                            v-model="username"
                                            required
                                            @input="$v.username.$touch()"
                                            @blur="$v.username.$touch()"
                                            :error-messages="usernameErrors"
                                    ></v-text-field>

                                    <v-text-field
                                            id="password"
                                            label="Password"
                                            name="password"
                                            prepend-icon="mdi-lock"
                                            type="password"
                                            v-model="password"
                                            required
                                            @input="$v.password.$touch()"
                                            @blur="$v.password.$touch()"
                                            :error-messages="passwordErrors"
                                    ></v-text-field>
                                <v-btn color="primary" type="submit">Login</v-btn>
                            </v-card-text>
                            <v-card-actions>
                                <img src="../assets/btn_google_signin_dark_normal_web.png"  @click="authenticate()" class="googleSignIn" />
                            </v-card-actions>
                            </v-form>
                        </v-card>

                    </v-col>
                </v-row>
            </v-container>
        </v-main>
    </v-app>
</template>

<script>

    import Clean from "../layouts/Clean";
    import { validationMixin } from 'vuelidate'
    import { required } from 'vuelidate/lib/validators'

    export default {
        metaInfo: {
            title: 'Login'
        },
        mixins: [validationMixin],

        validations: {
            username: { required },
            password: { required }
        },
        props: {
            source: String,
        },
        created() {
            this.$emit('update:layout', Clean)
        },
        data () {
            return {
                username: null,
                password: null,
                submitStatus: false,
                submitError: null
            }
        },
        computed: {
            passwordErrors () {
                const errors = []
                if (!this.$v.password.$dirty) return errors
                !this.$v.password.required && errors.push('Password is required.')
                return errors
            },
            usernameErrors () {
                const errors = []
                if (!this.$v.username.$dirty) return errors
                !this.$v.username.required && errors.push('Username is required')
                return errors
            },
        },

        methods: {
            // Log the user in
            authenticate() {
                this.$store.dispatch('auth/loginGoogle').then(() => {
                    this.$router.push({name:'home'})
                })
            },

            login() {
                this.$v.$touch()
                this.submitError = null
                console.log(this.$v.$invalid)
                if (this.$v.$invalid) {
                    this.submitStatus = 'ERROR'
                } else {
                    this.submitStatus = 'PENDING'
                    this.$store.dispatch('auth/loginPassword', {
                        username: this.username,
                        password: this.password
                    }).then(() => {
                        this.$router.push({name: 'home'})
                    }).catch((err) => {
                        console.log(err);
                        this.submitError = "Username and/or Password are not valid"
                        this.submitStatus = 'ERROR'
                    })
                }
                return false;
            },

        }
    }
</script>

<style scoped>

    .googleSignIn{
        cursor: pointer;
    }

</style>